var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 0.999995,
    width: 62,
    height: 62,
    rx: 31,
    transform: "rotate(90 63 0.999995)",
    stroke: "#222222",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 33C44.5523 33 45 32.5523 45 32C45 31.4477 44.5523 31 44 31L44 33ZM19.2929 31.2929C18.9024 31.6834 18.9024 32.3166 19.2929 32.7071L25.6569 39.0711C26.0474 39.4616 26.6805 39.4616 27.0711 39.0711C27.4616 38.6805 27.4616 38.0474 27.0711 37.6569L21.4142 32L27.0711 26.3431C27.4616 25.9526 27.4616 25.3195 27.0711 24.9289C26.6805 24.5384 26.0474 24.5384 25.6569 24.9289L19.2929 31.2929ZM44 31L20 31L20 33L44 33L44 31Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.2cd11ad3ce60b0c3c7585117afaa4e20.svg";
export { ForwardRef as ReactComponent };